import Loadable from 'react-loadable';
import ProgressLoader from "../ProgressLoader";

export default Loadable({
    loader: () => import('./Video'),
    loading: ProgressLoader
});
